import React from "react";
// @ts-strict-ignore
import type { Document } from "@contentful/rich-text-types";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";

import { Heading } from "app/_components/components/Text/Heading";
import { ContentBox } from "./AboutCoin.styled";

interface AboutCoinProps {
  aboutCoin: AboutProps;
  contentUk?: Document;
}
interface AboutProps {
  title: string;
  description: Document | null;
}

const renderOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node: any, children: any) => (
      <p className="!text-[#676868]">{children}</p>
    )
  }
};

const AboutCoin = (props: AboutCoinProps) => {
  const { title, description } = props?.aboutCoin || {};
  const { contentUk } = props;
  return (
    <ContentBox>
      {title && (
        <Heading
          size="sm"
          className="tablet:mb-[24px] tablet:!text-[24px] tablet:!leading-[28px] tablet:!tracking-[-0.5px] tablet:!font-medium mb-[16px] !text-[20px] !leading-[28px] !font-semibold"
        >
          {title}
        </Heading>
      )}

      {description && (
        <div className="flex flex-col">
          {documentToReactComponents(description, renderOptions)}
        </div>
      )}
      {contentUk && (
        <div className="flex flex-col">
          {documentToReactComponents(contentUk, renderOptions)}
        </div>
      )}
    </ContentBox>
  );
};
export default AboutCoin;
